import React from 'react'
import { IProps } from './index'

export const SearchIcon = ({ stroke }: IProps): React.ReactElement => {
  return (
    <svg
      className="search-icon"
      viewBox="0 0 16 17"
      width="16"
      height="17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6" stroke={stroke} strokeWidth="2" />
      <path d="m15 16-4-4" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

SearchIcon.defaultProps = {
  stroke: '#a2a2a2',
}
